var chunkMapping = {
	"320": [
		50320
	],
	"1344": [
		61344
	],
	"2458": [
		62458
	],
	"2510": [
		2510
	],
	"3758": [
		93758
	],
	"3904": [
		13904
	],
	"5210": [
		15210
	],
	"5312": [
		75312
	],
	"5692": [
		15692
	],
	"8024": [
		98024
	]
};
var idToExternalAndNameMapping = {
	"2510": [
		"default",
		"./ReportModule",
		52827
	],
	"13904": [
		"default",
		"./Admin",
		72099
	],
	"15210": [
		"default",
		"./Customer",
		48357
	],
	"15692": [
		"default",
		"./Payment",
		59623
	],
	"50320": [
		"default",
		"./Finance",
		33703
	],
	"61344": [
		"default",
		"./Claim",
		5473
	],
	"62458": [
		"default",
		"./Underwriting",
		99331
	],
	"75312": [
		"default",
		"./Sales",
		17356
	],
	"93758": [
		"default",
		"./ProductBuilder",
		44272
	],
	"98024": [
		"default",
		"./Receipt",
		94229
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}